import { BotDifficulty, BotSpeedSettings, DiceSettingEnum, ExtensionSettingEnum, GameSettings, GameSpeedSettings, GameTypeEnum, MapSettingEnum, ModeSettingEnum, ScenarioSettingEnum } from '@colonist/game-base-types';
import { BeginnerModeLevel, getCardDiscardLimitForBeginnerModeLevel, getMapForBeginnerModeLevel, getVPToWinForBeginnerModeLevel } from '@colonist/game-beginner-mode';
import { GameModeDataController } from '@colonist/shared-types';
const BOT_GAME_BOTS_BY_DIFFICULTY = {
    [BotDifficulty.BotEasy]: [
        BotDifficulty.BotEasy,
        BotDifficulty.BotEasy,
        BotDifficulty.BotEasy
    ],
    [BotDifficulty.BotMedium]: [
        BotDifficulty.BotMedium,
        BotDifficulty.BotEasy,
        BotDifficulty.BotEasy
    ],
    [BotDifficulty.BotHard]: [
        BotDifficulty.BotMedium,
        BotDifficulty.BotMedium,
        BotDifficulty.BotMedium
    ]
};
const RUSH_BOT_SPEED_BY_DIFFICULTY = {
    [BotDifficulty.BotEasy]: BotSpeedSettings.Slow,
    [BotDifficulty.BotMedium]: BotSpeedSettings.Normal,
    [BotDifficulty.BotHard]: BotSpeedSettings.Fast
};
export class PremadeGameSettings {
    static getGameSettingsForStandardRoom(id) {
        const setting = new GameSettings(id, GameTypeEnum.CreatedRoomGame);
        setting.privateGame = true;
        setting.diceSetting = DiceSettingEnum.Balanced;
        setting.friendlyRobber = true;
        return setting;
    }
    static applyRushDefaults(setting) {
        const rushModeData = GameModeDataController.getModeDataForMode(ModeSettingEnum.ColonistRush4P);
        if (rushModeData == undefined) return;
        setting.modeSetting = rushModeData.modeSetting;
        setting.extensionSetting = rushModeData.extensionSetting;
        setting.mapSetting = rushModeData.defaultMap;
        setting.cardDiscardLimit = rushModeData.defaultCardDiscardLimit;
        setting.friendlyRobber = rushModeData.defaultFriendlyRobber;
        setting.victoryPointsToWin = rushModeData.defaultVPsToWin;
        setting.gameSpeed = GameSpeedSettings.Rush5s;
        setting.botSpeed = BotSpeedSettings.Fast;
    }
    static beginnerMode(id, level = BeginnerModeLevel.Level1) {
        const setting = new GameSettings(id, GameTypeEnum.BeginnerMode);
        setting.botSpeed = BotSpeedSettings.Normal;
        setting.gameSpeed = GameSpeedSettings.Base12000s;
        setting.modeSetting = ModeSettingEnum.BeginnerModeClassic4P;
        setting.diceSetting = DiceSettingEnum.Random;
        setting.mapSetting = getMapForBeginnerModeLevel(level);
        setting.victoryPointsToWin = getVPToWinForBeginnerModeLevel(level);
        setting.cardDiscardLimit = getCardDiscardLimitForBeginnerModeLevel(level);
        return setting;
    }
    static botGame(id, context) {
        const settings = new GameSettings(id, context.gameTypeEnum);
        for (const key of Object.keys(context)){
            if (!(key in settings)) continue;
            settings[key] = context[key];
        }
        return settings;
    }
    static getBotGameBots(difficulty) {
        return [
            ...BOT_GAME_BOTS_BY_DIFFICULTY[difficulty]
        ];
    }
    static getRushBotGameBotSpeed(difficulty) {
        var _RUSH_BOT_SPEED_BY_DIFFICULTY_difficulty;
        return (_RUSH_BOT_SPEED_BY_DIFFICULTY_difficulty = RUSH_BOT_SPEED_BY_DIFFICULTY[difficulty]) !== null && _RUSH_BOT_SPEED_BY_DIFFICULTY_difficulty !== void 0 ? _RUSH_BOT_SPEED_BY_DIFFICULTY_difficulty : BotSpeedSettings.Fast;
    }
    static getGameSettingsForFreeMap(id, freeMap) {
        const setting = new GameSettings(id, GameTypeEnum.CreatedRoomGame);
        setting.hideBankCards = true;
        setting.gameSpeed = GameSpeedSettings.Base60s;
        setting.botSpeed = BotSpeedSettings.Fast;
        setting.mapSetting = freeMap;
        return setting;
    }
    static getGameSettingsForBeginnerMode(id) {
        const setting = PremadeGameSettings.beginnerMode(id);
        setting.hideBankCards = false;
        setting.diceSetting = DiceSettingEnum.Random;
        setting.friendlyRobber = false;
        setting.privateGame = true;
        setting.karmaActive = false;
        return setting;
    }
    static getGameSettingsForTournamentRoom(id) {
        const setting = new GameSettings(id, GameTypeEnum.CreatedTournamentRoom);
        setting.privateGame = true;
        setting.hideBankCards = true;
        setting.playOrderSelectionActive = false;
        return setting;
    }
    static getGameSettingsForCustomLinkRoom(id) {
        const setting = PremadeGameSettings.getGameSettingsForStandardRoom(id);
        setting.privateGame = true;
        return setting;
    }
    static getGameSettingsForDiscordActivityLobby(id) {
        const setting = PremadeGameSettings.getGameSettingsForStandardRoom(id);
        setting.privateGame = true;
        setting.karmaActive = false;
        return setting;
    }
    static matchmakingClassic4P() {
        const setting = new GameSettings('', GameTypeEnum.MatchmakingGame);
        setting.modeSetting = ModeSettingEnum.Classic4P;
        setting.extensionSetting = ExtensionSettingEnum.Players4;
        setting.scenarioSetting = ScenarioSettingEnum.None;
        setting.mapSetting = MapSettingEnum.Classic4P;
        setting.diceSetting = DiceSettingEnum.Random;
        setting.hideBankCards = true;
        setting.gameSpeed = GameSpeedSettings.Base60s;
        setting.botSpeed = BotSpeedSettings.Fast;
        return setting;
    }
    static matchmakingClassic1v1() {
        const setting = new GameSettings('', GameTypeEnum.MatchmakingGame);
        setting.modeSetting = ModeSettingEnum.Classic4P;
        setting.maxPlayers = 2;
        setting.extensionSetting = ExtensionSettingEnum.Players4;
        setting.scenarioSetting = ScenarioSettingEnum.None;
        setting.mapSetting = MapSettingEnum.Classic4P;
        setting.diceSetting = DiceSettingEnum.Balanced;
        setting.hideBankCards = true;
        setting.gameSpeed = GameSpeedSettings.Base30s;
        setting.friendlyRobber = true;
        setting.victoryPointsToWin = 15;
        setting.cardDiscardLimit = 9;
        return setting;
    }
    static matchmakingCitiesAndKnights() {
        const setting = new GameSettings('', GameTypeEnum.MatchmakingGame);
        setting.modeSetting = ModeSettingEnum.CitiesAndKnights4P;
        setting.extensionSetting = ExtensionSettingEnum.Players4;
        setting.scenarioSetting = ScenarioSettingEnum.None;
        setting.mapSetting = MapSettingEnum.Classic4P;
        setting.diceSetting = DiceSettingEnum.Random;
        setting.hideBankCards = true;
        setting.gameSpeed = GameSpeedSettings.Base60s;
        setting.victoryPointsToWin = 13;
        return setting;
    }
    static matchmakingRush4P() {
        const setting = new GameSettings('', GameTypeEnum.MatchmakingGame);
        setting.modeSetting = ModeSettingEnum.ColonistRush4P;
        setting.extensionSetting = ExtensionSettingEnum.Players4;
        setting.scenarioSetting = ScenarioSettingEnum.None;
        setting.mapSetting = MapSettingEnum.Classic4P;
        setting.diceSetting = DiceSettingEnum.Balanced;
        setting.hideBankCards = true;
        setting.gameSpeed = GameSpeedSettings.Rush5s;
        setting.botSpeed = BotSpeedSettings.Fast;
        setting.cardDiscardLimit = 9;
        setting.friendlyRobber = true;
        return setting;
    }
    static matchmakingShuffle() {
        const setting = new GameSettings('', GameTypeEnum.MatchmakingGame);
        setting.hideBankCards = true;
        setting.gameSpeed = GameSpeedSettings.Base60s;
        setting.botSpeed = BotSpeedSettings.Fast;
        setting.diceSetting = DiceSettingEnum.Balanced;
        setting.friendlyRobber = true;
        return setting;
    }
    static testSetting() {
        const setting = new GameSettings('idid', GameTypeEnum.Unknown);
        setting.modeSetting = ModeSettingEnum.TutorialClassic4P;
        setting.mapSetting = MapSettingEnum.TutorialClassic4P;
        setting.gameSpeed = GameSpeedSettings.Base30s;
        setting.botSpeed = BotSpeedSettings.Fast;
        return setting;
    }
}
PremadeGameSettings.DEFAULT_RUSH_BOT_DIFFICULTY = BotDifficulty.BotMedium;
